import { RadioBooleanField } from '@cibo/ui'
import { FormLabel, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailEditorProps } from '../types'

export const WetlandDesignationEditor = ({
  fieldModels,
  name = 'wetlandDesignationEditor',
}: DetailEditorProps) => {
  const { t } = useTranslation('@cibo/landmanager/WetlandDesignationEditor')
  return (
    <Stack spacing={2}>
      <Stack>
        {/* {overrideWarning} */}
        <FormLabel htmlFor={`${name}.overlaysWetland`}>
          {t('overlaysWetland', { count: fieldModels.length })}
        </FormLabel>
        <RadioBooleanField name={`${name}.overlaysWetland`} />
      </Stack>
    </Stack>
  )
}
